import { types } from "mobx-state-tree";

export const Lga = types.model("Lga", {
    id: types.identifier,
    type: types.literal("lga"),
    attributes: types.model({
        state_code: types.string,
        name: types.string
    })
})